import { BlockType, type Block } from '@/types';

const AUTO_HEIGHT_TYPES = new Set<BlockType>([
  BlockType.CONTENT_PAGE,
  BlockType.PLAN_VAN_AANPAK,
  BlockType.INVESTMENT,
  BlockType.SIGNATURE_PAGE,
]);

export function isAutoHeightBlock(type: BlockType): boolean {
  return AUTO_HEIGHT_TYPES.has(type);
}

function stripHtml(html: string): string {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();
}

export function isRenderableBlock(block: Block): boolean {
  if (block.type !== BlockType.TEXT) return true;

  const content = block.content as Record<string, unknown>;
  const html = typeof content.html === 'string' ? content.html : '';
  const text = typeof content.text === 'string' ? content.text : '';

  return stripHtml(html).length > 0 || text.trim().length > 0;
}
